import { connect } from 'react-redux';
import { flagEnabled } from '@wix/da-shared-react/pkg/redux/flags';
import { AppState } from '../../../../types/store';
import {
  getProfileOwnerStats,
  isCurrentUserProfileOwner,
} from '../../../selectors/users';
import { getModuleType } from '../../../selectors/modules';
import {
  getAllInstalledModuleIds,
  getSectionLayoutVersion,
} from '../../../selectors/layout';
import {
  ModuleTypeToStatNameMap,
  ModuleTypeToWidgetComponentMap,
} from './constants';
import { ModuleType } from '../../../../types/modules';
import shortenNumber from '@wix/da-shared-react/pkg/utils/shortenNumber';

const section = 'about';

export default connect(
  (state: AppState, props) => {
    const stats = getProfileOwnerStats(state);
    const isOwner = isCurrentUserProfileOwner(state);
    const isStatsFeatureEnabled = flagEnabled(state, 'stats');
    const routes = getAllInstalledModuleIds(state, section)
      .map(moduleId => {
        const moduleType = getModuleType(state, moduleId);
        if (
          !moduleType ||
          !ModuleTypeToWidgetComponentMap.hasOwnProperty(moduleType)
        ) {
          return undefined;
        }
        const statName = ModuleTypeToStatNameMap[moduleType];
        const statValue = stats[statName];
        const hideItem = !isOwner && statValue === 0;
        if (hideItem) {
          return undefined;
        }
        const formattedCount =
          moduleType !== ModuleType.MY_COMMENTS && // we don't show count for My comment item
          statValue &&
          shortenNumber(statValue);
        return {
          hash: moduleType,
          transKey: `pages.about.navmenu.${moduleType}`,
          count: formattedCount,
        };
      })
      .filter(route => route);
    const layoutVersion = getSectionLayoutVersion(state, section);
    return {
      stats,
      routes,
      layoutVersion,
      isStatsFeatureEnabled,
    };
  },
  {}
);
